import { useState, useCallback } from 'react';
import { checkCommunityEmail } from '@/service';
import { COMMUNITY_SITES, CENTER_TO_LOCALES, APPID_TO_LOCALE } from '@/constants/forum';

type CommunityStatus = 'registered' | 'not_registered' | 'no_account' | null;

export function useCheckCommunityEmail() {
    const [communityStatus, setCommunityStatus] = useState<CommunityStatus>(null);
    const [availableLocales, setAvailableLocales] = useState<string[]>(COMMUNITY_SITES);
    const [registeredLocale, setRegisteredLocale] = useState<string | null>(null);
    /* 是否已注册 true 已注册 false 未注册 */
    const [isRegistered, setIsRegistered] = useState(false);

    const checkEmail = useCallback(async (email: string): Promise<CommunityStatus> => {
        try {
            const res: any = await checkCommunityEmail({ email });
            if (res.code === '0' && res.data?.appId) {
                const locale = APPID_TO_LOCALE[String(res.data.appId)];
                setCommunityStatus('registered');
                setRegisteredLocale(locale || null);
                setAvailableLocales(locale ? [locale] : COMMUNITY_SITES);
                setIsRegistered(true)
                return 'registered';
            } else if (res.code === '0' && res.data?.centerList) {
                const locales = res.data.centerList.flatMap((center: string) => CENTER_TO_LOCALES[center] || []);
                const unique = [...new Set<string>(locales)];
                setCommunityStatus('not_registered');
                setRegisteredLocale(null);
                setAvailableLocales(unique.length > 0 ? unique : COMMUNITY_SITES);
                setIsRegistered(true)
                return 'not_registered';
            } else if (res.code === '1003') {
                setCommunityStatus('no_account');
                setRegisteredLocale(null);
                setAvailableLocales(COMMUNITY_SITES);
                setIsRegistered(false)
                return 'no_account';
            }
            return null;
        } catch {
            setCommunityStatus('no_account');
            setRegisteredLocale(null);
            setAvailableLocales(COMMUNITY_SITES);
            setIsRegistered(false)
            return 'no_account';
        }
    }, []);

    const reset = useCallback(() => {
        setCommunityStatus(null);
        setAvailableLocales(COMMUNITY_SITES);
        setRegisteredLocale(null);
    }, []);

    return { communityStatus, availableLocales, registeredLocale, checkEmail, reset, isRegistered };
}
